import React, { Component } from 'react';
import PropTypes from 'prop-types';

import itemDefault from '../../../../images/item-default.png';

/**
 * This whole class is a little gross, but it tries to grab an image to show,
 * but starts by showing a placeholder until the real thing is ready. Designed
 * to work around the fact that thumbnails for new uploads might not yet be
 * generated by Lambda when we go to retrieve them.
 */
class AttachmentImage extends Component {
  state = {
    source: itemDefault,
  };

  componentDidMount() {
    this.loadImage();
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  loadImage = () => {
    const { imgSrc } = this.props;
    const ts = Date.now();
    const img = new Image();

    img.onerror = () => {
      if (Date.now() - ts < 10000) {
        this.timer = setTimeout(() => {
          img.src = imgSrc;
        }, 1000);
      }
    };
    img.onload = () => {
      this.setState({ source: imgSrc });
    };
    img.src = imgSrc;
  };

  render() {
    return <img src={this.state.source} alt={this.props.alt} />;
  }
}

AttachmentImage.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

export default AttachmentImage;



// WEBPACK FOOTER //
// ./src/components/pages/collections/items/AttachmentImage.jsx